// removed by extract-text-webpack-plugin
module.exports = {"portal-toolbar-brand":"portal-toolbar-brand___B6UQp","portal-toolbar-brand-text":"portal-toolbar-brand-text___2kYmA","portal-sidenav-classic":"portal-sidenav-classic___bpVyT","portal-sidenav-toolbar":"portal-sidenav-toolbar___3SFCm","portal-sidenav-boxed":"portal-sidenav-boxed___2upM-","portal-sidenav-compact":"portal-sidenav-compact___1XFne","portal-sidenav-funky":"portal-sidenav-funky___yLYpU"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/components/sidenav/sidenav.module.scss
// module id = 906
// module chunks = 82